import type { TFunction } from "i18next"
import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"
import useToggle from "@hooks/use_toggle"
import i18next from "@utils/localization"

export type MarketplaceOrdersFormData = {
  customerId?: string | undefined
  marketplaceType?: string
  // startDate?: Date
  // endDate?: Date
  filterTrigger?: number
}

type MarketplaceOrdersPageContextProps = {
  translate: TFunction<"translation", undefined>
  isLeftDrawerOpen?: boolean
  toggleIsLeftDrawerOpen?: () => void
  filters: MarketplaceOrdersFormData
  setFilters: React.Dispatch<React.SetStateAction<MarketplaceOrdersFormData>>
}

const defaultValues: MarketplaceOrdersPageContextProps = {
  translate: i18next.t,
  filters: {},
  setFilters: () => {}
}

const MarketplaceOrdersPageContext = createContext(defaultValues)

export function MarketplaceOrdersPageContextProvider(props: {
  children: React.ReactNode | React.ReactNode[]
}) {
  const { translate } = useAppContext()
  const [isLeftDrawerOpen, toggleIsLeftDrawerOpen] = useToggle(true)
  const [filters, setFilters] = React.useState<MarketplaceOrdersFormData>({
    customerId: "ALL",
    marketplaceType: "ALL"
  })

  return (
    <MarketplaceOrdersPageContext.Provider
      value={{
        ...defaultValues,
        translate,
        isLeftDrawerOpen,
        toggleIsLeftDrawerOpen,
        filters,
        setFilters
      }}
    >
      {props.children}
    </MarketplaceOrdersPageContext.Provider>
  )
}

export function useMarketplaceOrdersPageContext() {
  const context = useContext(MarketplaceOrdersPageContext)
  if (context === undefined) {
    throw new Error("MarketplaceOrdersPageContext Error")
  }
  return context
}
